import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import Logo from '../../atoms/Logo'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 300;
`

const logoTitle = props => {
  const { title, children } = props
  return (
    <Content>
      <Logo />
      {children ? children : <span className="typo-title-medium">{title}</span>}
    </Content>
  )
}

logoTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}

export default logoTitle
